// extracted by mini-css-extract-plugin
export var noiseWrapper = "styles-module--noiseWrapper--168Z7";
export var darkWrapper = "styles-module--darkWrapper--2iVP9";
export var noise = "styles-module--noise--38j4c";
export var darkNoise = "styles-module--darkNoise--lfNH_";